const klaroConfig = {
    version: 1,
    elementID: 'klaro',
    storageMethod: 'localStorage',
    storageName: 'klaro',
    htmlTexts: true,
    cookieExpiresAfterDays: 365,

    default: false,
    mustConsent: false,
    acceptAll: true,
    hideDeclineAll: false,
    hideLearnMore: false,

    translations: {
        fr: {
            consentModal: {
                title: 'Gestion des cookies',
                description: 'Nous utilisons des cookies pour améliorer votre expérience sur notre site. Vous pouvez choisir les services que vous souhaitez activer.',
            },
            consentNotice: {
                title: 'Cookies',
                description: 'Nous utilisons des cookies pour les statistiques et pour afficher la carte des points de collecte. Acceptez-vous leur utilisation ?',
                learnMore: 'Paramétrer',
            },
            acceptAll: 'Tout accepter',
            acceptSelected: 'Accepter la sélection',
            decline: 'Tout refuser',
            ok: 'OK',
            save: 'Enregistrer',
            close: 'Fermer',
            purposes: {
                functional: 'Fonctionnel',
                analytics: 'Statistiques',
                marketing: 'Marketing',
            },
            googleAnalytics: {
                title: 'Google Analytics',
                description: 'Nous permet de mesurer l\'audience du site et d\'améliorer votre expérience.',
            },
            googleMaps: {
                title: 'Google Maps',
                description: 'Affiche la carte des points de collecte de briquets.',
            },
        },
    },

    lang: 'fr',

    services: [
        {
            name: 'googleAnalytics',
            title: 'Google Analytics',
            purposes: ['analytics'],
            required: false,
            default: false,
            cookies: [
                [/^_ga/, '/'],
                [/^_gid/, '/'],
                [/^_gat/, '/'],
            ],
            onAccept: `
                // Charge Google Analytics
                if (!document.getElementById('gtag-script')) {
                    const script = document.createElement('script');
                    script.id = 'gtag-script';
                    script.async = true;
                    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-7B2X6T8RR7';
                    document.head.appendChild(script);

                    window.dataLayer = window.dataLayer || [];
                    function gtag(){dataLayer.push(arguments);}
                    window.gtag = gtag;
                    gtag('js', new Date());
                    gtag('config', 'G-7B2X6T8RR7');
                }
            `,
            onDecline: `
                // Supprime les cookies GA
                document.cookie = '_ga=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
                document.cookie = '_gid=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
                document.cookie = '_gat=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
            `,
        },
        {
            name: 'googleMaps',
            title: 'Google Maps',
            purposes: ['functional'],
            required: false,
            default: true,
            cookies: [
                [/^NID/, '/', '.google.com'],
                [/^CONSENT/, '/', '.google.com'],
                [/^1P_JAR/, '/', '.google.com'],
            ],
            onAccept: `
                const mapPlaceholder = document.getElementById('map-placeholder');
                const mapIframe = document.getElementById('map-iframe');
                if (mapPlaceholder) mapPlaceholder.style.display = 'none';
                if (mapIframe) {
                    mapIframe.src = mapIframe.dataset.src;
                    mapIframe.style.display = 'block';
                }
            `,
            onDecline: `
                const mapPlaceholder = document.getElementById('map-placeholder');
                const mapIframe = document.getElementById('map-iframe');
                if (mapPlaceholder) mapPlaceholder.style.display = 'flex';
                if (mapIframe) {
                    mapIframe.src = '';
                    mapIframe.style.display = 'none';
                }
            `,
        },
    ],
};

export default klaroConfig;